module.exports = __webpack_public_path__ + "img/transaction.0194360d.svg";